import { Box } from '@mui/material';

type Props = {
  children?: React.ReactNode;
  styles?: React.CSSProperties;
  id?: string;
  className?: string;
};

function UiBox({ children, styles, ...rest }: Props) {
  return (
    <Box sx={styles} {...rest}>
      {children}
    </Box>
  );
}

export default UiBox;
